export const APPROVAL_RC_QUESTION_ID = "s6q1";
export const MAJOR_CATEGORY_QUESTION_ID = "q3a";
export const FPIM_SETUP_TYPE_QUESTION_ID = "FPIMSetupType";
export const APPROVAL_ITIS_MAJOR_CATEGORY = "ITC Equipment";
export const APPROVAL_ITIS_FPIM_SETUP_TYPE = "T-IT Devices-WT";
export const PROJECT_TYPE_ASSET_PURCHASE_CODE = "purchaseListedItem";
export const COST_THRESHOLD_FOR_APPROVAL_ESCALATION = 250000;

export const CAPITAL_ACCOUNTANT_ROLE_ID =
	"994AC6F0-E1AC-4508-AD11-5F2682013983";
export const FINANCE_LEAD_ROLE_ID = "C0A2D521-B06B-4083-9E5A-D1671A8E6CD7";

//for conditional workflow of management reserve
export const SOURCE_PROJECT_QUESTION_ID = "sourceProjectCode";
export const MANAGEMENT_RESERVE_SOURCE_PROJECT = "Management Reserve";
